import { lazy } from 'react';
import Loadable from "../Components/Loadable";
import AuthGuard from "../utils/route-guard/AuthGuard";
import MainLayout from "../layout/MainLayout";
import OAuthPopup from "../OAuth2/OAuthPopup";
import React from "./index";

const AppKanban = Loadable(lazy(() => import('../pages/apps/kanban')));
const AppKanbanBacklogs = Loadable(lazy(() => import('../sections/apps/kanban/Backlogs')));
const AppKanbanBoard = Loadable(lazy(() => import ('../sections/apps/kanban/Board')));
const MaintenanceComingSoon = Loadable(lazy( () => import ('../pages/maintenance/coming-soon')));
const HomePage = Loadable(lazy( () => import ('../pages/Home')));
const UserProfilePage = Loadable(lazy( () => import ('../pages/profiles/user')));
const PersonalTab = Loadable(lazy( () => import ('../sections/apps/profiles/user/TabPersonal')));
const PasswordTab = Loadable(lazy( () => import ('../sections/apps/profiles/user/TabPassword')));
const PaymentTab = Loadable(lazy( () => import ('../sections/apps/profiles/user/TabPayment')));
const XeroIntegrationsTab = Loadable(lazy( () => import ('../sections/apps/profiles/user/XeroIntegrations')));
const SubscriptionUsersTab = Loadable(lazy( () => import ('../sections/apps/profiles/user/TabUsers')));
const AnalyticsPage = Loadable(lazy( () => import ('../pages/dashboard/analytics')));
const DashboardSummary = Loadable(lazy(() => import('../sections/apps/dashboard/Summary')));
const DashboardPayables = Loadable(lazy(() => import('../sections/apps/dashboard/Payables')));
const DashboardReceivables = Loadable(lazy(() => import('../sections/apps/dashboard/Receivables')));
const DashboardMergers = Loadable(lazy(() => import('../sections/apps/dashboard/Mergers')))
const DashboardEmployees = Loadable(lazy(() => import('../sections/apps/dashboard/Employees')));
// const FAQPage = Loadable(lazy(() => import ('../pages/faq/faq')));
const ContactUs = Loadable(lazy( () => import('../pages/contact-us' )));
const PayablesDetails = Loadable(lazy(() => import('../pages/apps/payables/details')));
const ContactDetails = Loadable(lazy(() => import('../pages/apps/payables/contact')));
const GettingStartedPage = Loadable(lazy(() => import('../pages/getting-started/getting-started')))

const LoggedInRoutes = {
    path: '/',
    children: [
        {
            path: '/',
            element: (
                <AuthGuard>
                    <MainLayout />
                </AuthGuard>
            ),
            children:[
                {
                    path: '',
                    element: <HomePage />
                },
                {
                    path: 'contact-us',
                    element: <ContactUs />
                },
                {
                    path: 'callback',
                    element: <OAuthPopup />
                },
                {
                    path: 'callback-xero-integration',
                    element: <OAuthPopup />
                },
                // {
                //     path: 'taxchatbot',
                //     element: <MaintenanceComingSoon />
                // },
                // {
                //     path: 'faq',
                //     element: <FAQPage />
                // },
                {
                    path: 'getting-started',
                    element: <GettingStartedPage />
                },
                {
                    path: 'profiles/user',
                    element: <UserProfilePage />,
                    children: [
                        {
                            path: 'personal',
                            element: <PersonalTab />
                        },
                        {
                            path: 'payment',
                            element: <PaymentTab />
                        },
                        {
                            path: 'password',
                            element: <PasswordTab />
                        },
                        {
                            path: 'xero-integrations',
                            element: <XeroIntegrationsTab />
                        },
                        {
                            path: 'users',
                            element: <SubscriptionUsersTab />
                        }
                    ]
                },
                // {
                //     path: 'apps/kanban',
                //     element: <AppKanban />,
                //     children: [
                //         {
                //             path: 'board',
                //             element: <AppKanbanBoard />
                //         },
                //         {
                //             path: 'backlogs',
                //             element: <AppKanbanBacklogs />
                //         }
                //     ]
                // },
                {
                    path: 'invoice/details/:id',
                    element: <PayablesDetails />
                },
                {
                    path: 'contact/details/:id',
                    element: <ContactDetails />
                },
                {
                    path: 'analytics/dashboard',
                    element: <AnalyticsPage />,
                    children: [
                        {
                            path: 'summary',
                            element: <DashboardSummary />
                        },
                        {
                            path: 'payables',
                            element: <DashboardPayables />
                        },
                        {
                            path: 'receivables',
                            element: <DashboardReceivables />
                        },
                        {
                            path: 'mergers',
                            element: <DashboardMergers />
                        }
                        // {
                        //     path: 'employees',
                        //     element: <DashboardEmployees />
                        // }
                    ]
                }
            ]
        }
    ]
};

export default LoggedInRoutes;
